import { getPanelAccessToken } from './apiAuthProvider';

const getApiUrl = () => {
  const base = process.env.REACT_APP_API_URL ?? 'http://localhost:3001';
  return base.replace(/\/$/, '');
};

export const fetchPendingRefundSummary = async () => {
  const token = getPanelAccessToken();
  if (!token) return { total: 0, items: [] };

  const res = await fetch(`${getApiUrl()}/refunds/pending-summary`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    if (res.status === 403) return { total: 0, items: [] };
    throw new Error(`Pending refund summary failed (${res.status})`);
  }
  return res.json();
};

export const fetchRefundsByPayment = async (paymentId, saleId) => {
  const token = getPanelAccessToken();
  if (!token || !paymentId) return { data: [] };

  const qs = saleId ? `?saleId=${encodeURIComponent(saleId)}` : '';
  const res = await fetch(
    `${getApiUrl()}/refunds/by-payment/${encodeURIComponent(paymentId)}${qs}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  if (!res.ok) return { data: [] };
  return res.json();
};

export const manualCloseRefundRequest = async (refundRequestId, note) => {
  const token = getPanelAccessToken();
  if (!token) throw new Error('Oturum yok');
  const res = await fetch(
    `${getApiUrl()}/refunds/${encodeURIComponent(refundRequestId)}/manual-close`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ note }),
    },
  );
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json?.message || `Manuel kapatma başarısız (${res.status})`);
  }
  return json;
};

export const logRefundView = async ({ refundRequestId, paymentId, saleId, source }) => {
  const token = getPanelAccessToken();
  if (!token) return { ok: false };

  const res = await fetch(`${getApiUrl()}/refunds/log-view`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refundRequestId, paymentId, saleId, source }),
  });
  if (!res.ok) return { ok: false };
  return res.json();
};
